/* import __COLOCATED_TEMPLATE__ from './cascade-drawer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();